<template>
  <div>
    <div class="animated fadeIn">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    </div>
    <b-card>
      <b-col xl="12" lg="12" md="12" sm="12">
        <b-button variant="danger" class="ml-4 float-right" @click="goBack">Voltar</b-button>
        <h3>&nbsp;Produtos - {{moment(datainicial).format("DD/MM/YYYY")}} à {{moment(datafinal).format("DD/MM/YYYY")}}</h3>
      </b-col>
    </b-card>
    <b-row>
      <b-col cols="12">
        <b-card style="padding-bottom: 0!important;">
          <b-row>
            <b-col cols="12" class="mt-3">
              <b-form-group>
                <b-input-group prepend="Pesquisar">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Digite para pesquisar"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-row>
                <b-col xl="6" lg="6" md="12" sm="12">
                  <b-form-group>
                    <b-input-group prepend="Quantidade por Página">
                      <b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions"></b-form-select>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col xl="6" lg="6" md="12" sm="12">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col cols="12">
        <b-card>
          <b-table
            bordered
            small
            hover
            head-variant="light"
            style="margin-bottom: 0!important; padding-bottom: 0!important;"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template v-slot:cell(lucro)="data">
              {{ (parseFloat(data.item.totalvenda) - parseFloat(data.item.totalcusto)).toFixed(2).replace(/\./g, ",") }}
            </template>
            <template v-slot:cell(perclucro)="data">
              {{ ((parseFloat(data.item.totalvenda) - parseFloat(data.item.totalcusto)).toFixed(2) * 100 / (parseFloat(data.item.totalvenda))).toFixed(2).replace(/\./g, ",") }}%
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import * as config from "@/config.json";
import moment from "moment";

export default {
  components: {
    moment
  },
  data: _ => {
    return {
      items: [],
      fields: [
        {
          key: "codigo",
          label: "Código",
          sortable: false,
          sortDirection: "desc"
        },
        {
          key: "descricao",
          label: "Descrição",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "totalcusto",
          label: "Custo",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "totalvenda",
          label: "Venda",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "lucro",
          label: "Lucro"
        },
        {
          key: "perclucro",
          label: "Percentual Lucro"
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      datainicial: "2019-08-01",
      datafinal: "2019-08-22"
    };
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },

  async beforeMount() {
    await this.receberProdutos();
    this.getRowCount(this.items);
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getRowCount(items) {
      this.totalRows = items.length;
    },
    async receberProdutos() {
      await axios
        .get(
          `${config.default.servidor}/gerencial/vendas-por-Produto/${
            this.datainicial
          }/${this.datafinal}/${localStorage.getItem("enterprise_id")}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            this.items = response.data.data;
          }
        });
    }
  }
};
</script>

<style>
</style>